import { ORM } from 'utility-ts-orm';
import { PollResultsQueryModel } from './../queries/poll_results_query_model';

angular
  .module('capability-ng-poll')
  .factory(
    'loadPollResultsCommand',
    function loadPollResultsCommandDefinition(
      $q: ng.IQService,
      $http: ng.IHttpService,
      ngPollResultsQueryModel: PollResultsQueryModel,
      defineCommand: any
    ): void {
      return defineCommand(
        'loadPollResultsCommand',
        function loadPollResultsCommand(deferred: ng.IDeferred<any>): void {
          deferred.resolve(ngPollResultsQueryModel.run());
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-poll/src/commands/load_poll_results_command.ts